import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import UndefinedErrorSnackbar from 'components/Snackbar/UndefinedErrorSnackbar';
import SentEmailAdminComp from './SentEmailAdmin/SentEmailAdminComp';
import * as dashboardActions from 'actions/admin/DashboardActions';

const SentEmailAdmin = (props) => {
  const { classes } = props;
  const { dashboard, defaultStates } = props;
  const {
    getSentAdminEmailList,
  } = props.dashboardActions;
  return (
    <div>
      {defaultStates.unDefinedError ? <UndefinedErrorSnackbar error_code={defaultStates.error} /> : ''}
      <SentEmailAdminComp
        getSentAdminEmailList={getSentAdminEmailList}
        sent_email_admin_list={dashboard.sent_email_admin_list.list === undefined ? [] : dashboard.sent_email_admin_list.list}
        sent_email_admin_count={dashboard.sent_email_admin_list.count === undefined ? 0 : dashboard.sent_email_admin_list.count}

        requesting={dashboard.requesting}
        message={dashboard.message}
        error_code={dashboard.error_code}
        classes={classes}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    dashboard: state.adDashboard,
    defaultStates: state.adDefaultStates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SentEmailAdmin);
